import { SUBCLUSTERS } from '../subclusters.js';

const HR_CLUSTER = {
    subclusters: [
        {
            key: SUBCLUSTERS.MANAGING_PROJECTS_PORTFOLIO,
        },
        {
            key: SUBCLUSTERS.PROJECT_MANAGEMENT,
        },
        {
            key: SUBCLUSTERS.HR_SERVICES,
        },
        {
            key: SUBCLUSTERS.HR_RECRUITING,
        },
        {
            key: SUBCLUSTERS.ONBOARDING_OFFBOARDING,
        },
        {
            key: SUBCLUSTERS.EMPLOYEE_ONBOARDING,
        },
        {
            key: SUBCLUSTERS.RECRUITMENT_PIPELINE,
        },
        {
            key: SUBCLUSTERS.EMPLOYEE_EXPERIENCE,
        },
        {
            key: SUBCLUSTERS.HR_REQUESTS,
        },
        {
            key: SUBCLUSTERS.EMPLOYEE_DIRECTORY,
        },
        {
            key: SUBCLUSTERS.COMPANY_EVENTS,
        },
        {
            key: SUBCLUSTERS.TASKS,
        },
        {
            key: SUBCLUSTERS.RESOURCE_MANAGEMENT,
        },
        {
            key: SUBCLUSTERS.MANAGING_ROUTINE_PROCESSES,
        },
        {
            key: SUBCLUSTERS.REPORTING_TO_EXECUTIVES,
        },
        {
            key: SUBCLUSTERS.BUSINESS_OPERATIONS,
        },
        {
            key: SUBCLUSTERS.CRM,
        },
    ],
};

export { HR_CLUSTER };
